import { HeaderFixed } from '@/components';
import { JarFilterButtons } from './JarFilterButtons';
import { JarSearchBox } from './JarSearchBox';
import { JarHeaderSubscriptions } from './JarHeaderSubscriptions';
import { JarHeaderUnauthenticated } from './JarHeaderUnauthenticated';
import { useContext } from 'react';
import AuthenticationContext from '@/context/AuthenticationContext';
import { css } from '@emotion/css';

export const JarHeader: React.FC = () => {
  const { isAuthenticated } = useContext(AuthenticationContext);

  return (
    <HeaderFixed className={cn.desktopReflowHeader} animatedShadow>
      {isAuthenticated ? <JarHeaderSubscriptions /> : <JarHeaderUnauthenticated />}
      <JarSearchBox />
      <JarFilterButtons />
    </HeaderFixed>
  );
};

const cn = {
  desktopReflowHeader: css`
    @media screen and (max-width: 360px) and (hover: hover) and (pointer: fine) {
      position: static;
    }
  `,
};
